import { plainText } from "../lib/text";
import type { Topic } from "../types";

export const ASSISTANTS = ["小红书内容助理", "热点监控助理"] as const;

export function topicTitle(topic: Pick<Topic, "title">): string {
  return plainText(topic.title) || "未命名选题";
}

/** Prefer 推荐理由, otherwise 切入角度. Empty stays blank instead of a dash. */
export function topicSubtitle(topic: Pick<Topic, "reason" | "angle">): string {
  return plainText(topic.reason) || plainText(topic.angle);
}

/** Prefer 来源助理, otherwise the reference source text. */
export function topicSource(topic: Pick<Topic, "sourceAssistant" | "sources">): string {
  return plainText(topic.sourceAssistant) || plainText(topic.sources);
}

export function topicAudience(topic: Pick<Topic, "audience">): string {
  return plainText(topic.audience);
}

/** Short label for the library column. Blank when the assistant is unknown. */
export function sourceShort(topic: Pick<Topic, "sourceAssistant">): string {
  const name = plainText(topic.sourceAssistant);
  if (name.includes("热点")) return "热点助理";
  if (name.includes("内容")) return "内容助理";
  return name;
}

export interface AssistantSnapshot {
  name: string;
  making: number;
  latestTitle: string;
  latestWhen: string;
}

export function assistantSnapshot(topics: Topic[], name: string): AssistantSnapshot {
  const mine = topics.filter((topic) => !topic.inTrash && topic.sourceAssistant === name);
  const making = mine.filter((topic) => topic.status === "制作中").length;
  const latest = [...mine].sort((left, right) => {
    const byDate = (right.createdDate ?? "").localeCompare(left.createdDate ?? "");
    if (byDate !== 0) return byDate;
    return (right.updatedAt ?? "").localeCompare(left.updatedAt ?? "");
  })[0];
  return {
    name,
    making,
    latestTitle: latest ? topicTitle(latest) : "",
    latestWhen: latest?.createdDate || latest?.updatedAt || "",
  };
}
